export default __webpack_public_path__ + "static/media/TiemposHeadline.c205f3a8.woff2";